import { Drawer } from 'antd'
import React from 'react'

import { drawerAndModalWidth } from '../../../util/guideline'
import { RollbackRfq } from './'

export const CancelTradeViaRfqDrawer = ({ isVisible, onClose, rfqToRollback, onSuccess }) => (
  <Drawer
    title="Cancel Trade via RFQ"
    placement="right"
    onClose={onClose}
    open={!!rfqToRollback}
    width={drawerAndModalWidth}
    destroyOnClose
    className="drawer-rfq"
  >
    {rfqToRollback && <RollbackRfq rfq={rfqToRollback} onSubmitSuccess={onSuccess} />}
  </Drawer>
)
